import { render } from "./situacaoGeral.vue?vue&type=template&id=3846f1f5&scoped=true"
import script from "./situacaoGeral.vue?vue&type=script&lang=js"
export * from "./situacaoGeral.vue?vue&type=script&lang=js"

import "./situacaoGeral.vue?vue&type=style&index=0&id=3846f1f5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3846f1f5"]])

export default __exports__